module.exports = __webpack_public_path__ + "img/avatar.d379a18.svg";